import _implicitStylesheets from "./button.css";
import _implicitScopedStylesheets from "./button.scoped.css?scoped=true";
import _amcAnalyticsInstrument from "amc/analyticsInstrument";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "type": "button"
};
const stc1 = {
  "name": "start"
};
const stc2 = [];
const stc3 = {
  key: 3
};
const stc4 = {
  "name": "end"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, ncls: api_normalize_class_name, ti: api_tab_index, s: api_slot, d: api_dynamic_text, t: api_text, h: api_element, c: api_custom_element} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [api_custom_element("amc-analytics-instrument", _amcAnalyticsInstrument, {
    props: stc0,
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics)),
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleClick))
    }
  }, [api_element("button", {
    className: api_normalize_class_name($cmp._className),
    attrs: {
      "part": "button",
      "role": "button",
      "aria-disabled": $cmp.disabled,
      "type": $cmp.type,
      "size": $cmp.size,
      "disabled": $cmp.disabled ? "" : null,
      "tabindex": api_tab_index($cmp.tabIndex)
    },
    key: 1,
    on: {
      "slotchange": _m2 || ($ctx._m2 = api_bind($cmp.handleSlotChange))
    }
  }, [api_slot("start", {
    className: api_normalize_class_name($cmp.slotsClasses.start),
    attrs: stc1,
    key: 2
  }, stc2, $slotset), api_slot("", stc3, [api_text(api_dynamic_text($cmp.label))], $slotset), api_slot("end", {
    className: api_normalize_class_name($cmp.slotsClasses.end),
    attrs: stc4,
    key: 4
  }, stc2, $slotset)])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["", "end", "start"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-588qujdi8op";
tmpl.legacyStylesheetToken = "ads-button_button";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
